<template>
  <div ref="pageContainer" tabindex="-1">
    <BaseTopLine> </BaseTopLine>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
      :key="counter"
    >
      <div class="tw-flex tw-items-end tw-justify-between tw-gap-[20px]">
        <div
          class="tw-flex tw-items-end tw-gap-[20px] tw-max-w-[1000px] tw-w-full"
        >
          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["city_delivery_register_text_25"] }}
            </label>
            <BaseSelect
              @input="resetSimpleFilter"
              v-model="selectedType"
              class="multiselect-type-1"
              :options="selectsOptions?.type"
              label="label"
              placeholder=""
              selectLabel=""
              deselectLabel=""
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div
            v-if="selectedType.value !== 'clients_type_fiz'"
            class="tw-app-input-container"
          >
            <label class="tw-app-input-container-label">{{
              dataLang["clients_register_text_159"]
            }}</label>
            <BaseInputNew
              @keyupEnter="loadData(1, true)"
              inputClass="tw-app-input-dark"
              placeholder=""
              input-name="clients__ur_inn"
              :horizontalTitle="true"
              value=""
              @input="updateValueFilter"
              :additionalParams="{}"
              inputRef="clients__ur_inn"
              inputMask="0000000000000000"
              maxLength="10"
            />
          </div>

          <div
            v-if="selectedType.value == 'clients_type_fiz'"
            class="tw-app-input-container"
          >
            <label class="tw-app-input-container-label">{{
              dataLang["clients_register_text_129"]
            }}</label>
            <BaseInputNew
              @keyupEnter="loadData(1, true)"
              inputClass="tw-app-input-dark"
              placeholder=""
              input-name="clients__name"
              @input="updateValueFilter"
              :horizontalTitle="true"
              value=""
              :additionalParams="{}"
            />
          </div>

          <div
            v-if="selectedType.value == 'clients_type_fiz'"
            class="tw-app-input-container !tw-w-[30%]"
          >
            <label class="tw-app-input-container-label">{{
              dataLang["clients_register_text_125"]
            }}</label>
            <BaseInputNew
              @keyupEnter="loadData(1, true)"
              inputClass="tw-app-input-dark"
              placeholder=""
              input-name="clients__fiz_date_birth"
              @input="updateValueFilter"
              :horizontalTitle="true"
              value=""
              :additionalParams="{}"
              inputRef="clients__fiz_date_birth"
              inputMask="00.00.0000"
              maxLength="10"
            />
          </div>

          <div class="tw-flex tw-flex-row">
            <button
              type="button"
              class="tw-app-btn-primary"
              @click="loadData(1, true)"
            >
              <!-- {{ dataLang["register_btn_filter_on"] }} -->
              Найти
            </button>
            <button
              type="button"
              class="tw-app-btn-light tw-whitespace-nowrap"
              @click="resetFilter"
            >
              {{ dataLang["register_btn_filter_off"] }}
            </button>
          </div>
        </div>

        <div class="tw-flex tw-items-end tw-gap-[20px]">
          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">{{
              dataLang["clients_register_text_127"]
            }}</label>
            <BaseInputNew
              @keyupEnter="$refs?.pageContainer?.focus(), loadData(1, true)"
              inputClass="tw-app-input-dark"
              input-name="clients__phone"
              @input="updateValueFilter"
              value=""
              inputRef="clients__phone"
              inputMask="+{7}(000)000-00-00"
              maxLength="16"
              :additionalParams="{}"
            />
          </div>
          <div class="tw-flex tw-flex-row">
            <button
              type="button"
              class="tw-app-btn-primary"
              @click="loadData(1, true)"
            >
              <!-- {{ dataLang["register_btn_filter_on"] }} -->
              Найти
            </button>
            <button
              type="button"
              class="tw-app-btn-light tw-whitespace-nowrap"
              @click="resetFilter"
            >
              {{ dataLang["register_btn_filter_off"] }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px]">
      <div class="tw-text-[12px] tw-text-forText tw-my-[15px] tw-text-right">
        {{ dataLang["clients_register_text_128"] }}
      </div>

      <div class="tw-flex tw-justify-end tw-my-[15px]">
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationClientBlackStateParams,
            limit: limitPaginationValue,
          }"
          :showLimitInput="true"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div>

      <div class="tw-relative">
        <BaseLoader v-if="localLoading"></BaseLoader>
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="clients__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          :checkbox-option="{
            hideSelectAll: false,
          }"
          v-if="!localLoading"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>

      <div
        class="tw-text-white tw-bg-[#ff2400] tw-text-center tw-p-[10px] tw-text-[12px] tw-mt-[15px]"
      >
        {{ dataLang["clients_register_text_138"] }}
      </div>
    </div>
    <div v-if="!localLoading">
      <gallery
        :images="gelleryList"
        :index="galleryExeples"
        @close="onCloseGallery"
      ></gallery>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import SmsPresetsModal from "./orders-modal/SmsPresetsModal.vue";
import EventBus from "@/event-bus.js";
import SendSomeSms from "@/components/reuse_modal/SendSomeSms.vue";
import { bootstrap, Tooltip } from "bootstrap";
import EditsTariffModal from "./tarrifs-modal/EditsTariffModal.vue";
import TariffModalCreate from "./tarrifs-modal/TariffModalCreate.vue";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";

import Vue from "vue";

import VueGallery from "vue-gallery";
export default {
  components: {
    VeTable,
    gallery: VueGallery,
  },

  data() {
    return {
      counter: 0,
      limitPaginationValue: 50,
      dataTimeSelect: { orders_from: [], orders_to: [] },
      selectsData: {
        types: [],
        statuses: [],
        ads: [],
        koef: [],
      },
      dataForDatePicker: { orders__ends: [] },
      indexForOpenImage: null,
      gelleryList: [],
      selectsFilter: {
        wanted: [],
      },
      selects: [],

      selectsOptions: {
        type: [
          {
            value: "clients_type_fiz",
            label: "Частное (физическое) лицо",
          },
        ],
      },
      selectedType: {
        value: "clients_type_fiz",
        label: "Частное (физическое) лицо",
      },
      galleryExeples: null,
      messageError: [],
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      activePagePagination: {},
      rowStyleOption: {
        stripe: true,
      },
      updateValueFilterObject: {},
      comissionState: false,
      cellSelectionOption: {
        enable: false,
      },
      eventCustomOption: {},
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            column.field == "clients__is_wanted" &&
            Boolean(row.clients__is_wanted)
          ) {
            return "client-status-danger";
          }
        },
      },
    };
  },
  methods: {
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    onCloseGallery() {
      this.gelleryList = [];
      this.galleryExeples = null;
    },
    updateValueFilter({ value, name }) {
      console.log(123);
      if (name == "clients__fiz_date_birth" && value.length > 9) {
        this.$set(
          this.updateValueFilterObject,
          name,
          value.split(".").reverse().join("-")
        );
      } else {
        console.log("value:" + value);
        if (value && value != "+7(") {
          this.$set(this.updateValueFilterObject, name, value);
        } else {
          this.$delete(this.updateValueFilterObject, name);
        }
      }
    },
    loadData(page = 1, search) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/selects/field/clients_types_face`)
          .then((data) => {
            this.selectsOptions.type = this.prepareLabelsForSelects(
              data.data.data.rows.clients_types_face
            );
          })
          .catch((e) => {}),
      ]).then(() => {
        GeneralService.get(`/clients/table/black${search ? "/search" : ""}`, {
          params: {
            ...(this.filter.length && { where: JSON.stringify(this.filter) }),
            ...this.updateValueFilterObject,
            limit: this.limitPaginationValue,
            page: page,
          },
        })
          .then((data) => {
            if (search) {
              this.$toast.success(data.data.message);
            }
            this.getClientBlackAll(data.data.data);
            this.dataTable = data.data.data.rows;

            // clients__blacklist_gallery

            this.gelleryList = [];
            this.localLoading = false;
          })
          .catch((e) => {
            console.log(e);
            if (e?.response?.data?.message) {
              this.$toast.error(e?.response?.data?.message, { duration: 5000 });
            } else {
              this.$toast.error("Неизвестная ошибка", { duration: 5000 });
            }
            this.localLoading = false;
            this.resetFilter();
          });
      });
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.loadData(1);

      this.selectsFilter = {
        wanted: [],
      };
      this.dataTimeSelect = {
        orders_from: [],
        orders_to: [],
      };
      this.updateValueFilterObject = {};
      this.dataForDatePicker = { orders__ends: [] };

      // this.$refs.globalDataFilter
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      // this.$refs.mainTable.$el
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      this.counter++;
    },

    resetSimpleFilter() {
      // this.$refs.mainTable.$el
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      this.updateValueFilterObject = {};

      // this.$refs.globalDataFilter
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.mod == "phone" && { mod: "phone" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },

    changeComission(data) {
      GeneralService.edit("/tariffs_car/setcomissiontype", {
        company_settings__tariff_table_comission_custom_or_top_cars: data,
      }).then((data) => {
        this.loadData();
      });
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    prepareLabelsForSelects(data, keyDataFromFetch) {
      let out = [];
      data.forEach((elem, index) => {
        out.push({
          value: Object.keys(elem)[0],
          label: Object.values(elem)[0],
        });
      });

      return out;
    },

    ...mapActions("clientBlackPagiation", ["getClientBlackAll"]),
  },
  mounted() {},
  created() {
    Promise.all([
      //   }),
    ]).then(() => {
      this.loadData(1);
    });
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("clientBlackPagiation", ["paginationClientBlackStateParams"]),
    ...mapGetters("clientBlackPagiation", ["numPages"]),
    columns() {
      return [
        {
          field: "clients__name",
          key: "12",
          title: this.dataLang["clients_register_text_129"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row }, h) => {
            return (
              <span>
                {row.clients__name || ""}
                {row.clients__id ? ` (${row.clients__id})` : ""}
              </span>
            );
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div class={"h-100"}>
          //       <div class={"text-center"}>{column.title}</div>

          //       <BaseInputNew
          //         placeholder=""
          //         style={"min-width: 120px"}
          //         disabled={false}
          //         onInput={this.fillFilter}
          //         additionalParams={{ type: "like" }}
          //         inputName={"clients__name"}
          //         value={""}
          //         nameSign={""}
          //       />
          //     </div>
          //   );
          // },
        },

        {
          field: "clients__fiz_date_birth",
          key: "13",
          title: this.dataLang["clients_register_text_130"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div>
          //       <div class={"text-center"}>{column.title}</div>

          //       <BaseInputNew
          //         placeholder=""
          //         style={"min-width: 60px"}
          //         disabled={false}
          //         onInput={this.fillFilter}
          //         additionalParams={{ type: "like" }}
          //         inputName={"clients__fiz_date_birth"}
          //         value={""}
          //         nameSign={""}
          //       />
          //     </div>
          //   );
          // },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.clients__fiz_date_birth
                  ? this.$time(row.clients__fiz_date_birth)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)
                  : ""}
              </span>
            );
          },
        },
        {
          field: "clients__phone",
          key: "14",
          title: this.dataLang["clients_register_text_131"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div>
          //       <div class={"text-center"}>{column.title}</div>

          //       <BaseInputNew
          //         placeholder=""
          //         style={"min-width: 60px"}
          //         disabled={false}
          //         onInput={this.fillFilter}
          //         additionalParams={{ type: "like" }}
          //         inputName={"clients__phone"}
          //         value={""}
          //         nameSign={""}
          //       />
          //     </div>
          //   );
          // },
        },
        {
          field: "companies__name",
          key: "15",
          title: this.dataLang["clients_register_text_132"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row }, h) => {
            return (
              <span>
                {row.companies__name || ""}
                {row.companies__id ? ` (${row.companies__id})` : ""}
              </span>
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "companies__phone",
          key: "1532",
          title: this.dataLang["clients_register_text_133"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "clients__blacklist_comment",
          key: "16",
          title: this.dataLang["clients_register_text_134"],
          align: "center",
          width: "18%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },

        {
          field: "",
          key: "1543",
          title: this.dataLang["clients_register_text_135"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let isShow = false;
            row.clients__blacklist_gallery.map((item) => {
              if (item.client_blacklist_gallery__file) {
                isShow = true;
              }
            });
            return (
              <img
                class={`cursor-pointer ${!isShow ? "d-none" : ""}`}
                onClick={() => {
                  row.clients__blacklist_gallery.map((item) => {
                    if (item.client_blacklist_gallery__file) {
                      this.gelleryList.push(
                        item.client_blacklist_gallery__file
                      );
                    }
                  });

                  this.galleryExeples = 0;
                }}
                src={require(`@/assets/icons/icon-gallery.svg`)}
              />
            );
          },
        },
        {
          field: "clients__amount_damge",
          key: "1153",
          title: this.dataLang["clients_register_text_136"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },

        {
          field: "clients__is_wanted",
          key: "1553",
          title: this.dataLang["clients_register_text_137"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            // Пожалуйста, срочно свяжитесь с инициатором и помогите провести задержание этого клиента! Не говорите клиенту про розыск!
            return (
              <span
                class={"d-flex align-items-center justify-content-center"}
                style={"height: 25px"}
                title={
                  row.clients__is_wanted
                    ? this.dataLang["clients_register_text_170"]
                    : this.dataLang["no"]
                }
              >
                {row.clients__is_wanted
                  ? this.dataLang["yes"]
                  : this.dataLang["no"]}
              </span>
            );
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div>
          //       <div class={"text-center"}>{column.title}</div>
          //       <BaseSelect
          //         vModel={this.selectsFilter.wanted}
          //         onInput={(e, w) => {
          //           if (
          //             !this.filter.find((x) => x.field == "clients__is_wanted")
          //           ) {
          //             this.filter.push({
          //               field: "clients__is_wanted",
          //               value: e.value,
          //             });
          //           } else {
          //             this.filter[
          //               this.filter.findIndex(
          //                 (x) => x.field == "clients__is_wanted"
          //               )
          //             ].value = e.value;
          //           }
          //         }}
          //         style={"min-width: 40px"}
          //         label={"label"}
          //         placeholder={""}
          //         id={"tariff_groups_for_car__name"}
          //         selectLabel={""}
          //         deselectLabel={""}
          //         options={[
          //           { label: "Да", value: 1 },
          //           { label: "Нет", value: 0 },
          //         ]}
          //       >
          //         <template slot="noOptions">
          //           {this.dataLang["select_empty"]}
          //         </template>
          //         <template slot="noResult">
          //           {this.dataLang["select_search_empty"]}
          //         </template>
          //         <template slot="selectedLabel">
          //           {this.dataLang["select_selected"]}
          //         </template>
          //         <template slot="deselectLabel">
          //           {this.dataLang["select_unselect"]}
          //         </template>
          //       </BaseSelect>
          //     </div>
          //   );
          // },
        },
      ];
    },
  },
};
</script>

<style>
.client-status-danger {
  background-color: #ff2400 !important;
  color: white !important;
}
</style>
